import { css } from '@emotion/react'
import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { theme, themeUtils } from 'styles/theme'

export const MapContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 34px 32px;
  border-radius: 20px;
  background-color: ${unifiedColors.surface.subdued};
  ${themeUtils.maxWidth.sm} {
    padding: 17px 15px;
  }
`

export const LocationContent = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: calc(100vh - 32px);
  max-height: 500px;
  border-radius: 20px;
  margin-top: 19px;
`

export const MapDisplayButtons = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  box-shadow: 0 0 0 2px rgb(0 0 0 / 10%);
  border-radius: 4px;
`
interface MapDisplayButtonProps {
  $isActive: boolean
}

export const MapDisplayButton = styled.button<MapDisplayButtonProps>`
  border: none;
  margin: 0;
  padding: 6px;
  background-color: ${theme.palette.surface.default};
  ${themeUtils.label}
  cursor: pointer;
  position: relative;
  &:hover {
    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      &:before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.05);
      }
    `}
`

export const BackToStartButton = styled.button`
  height: 29px;
  width: 29px;
  display: flex;
  padding-top: 4px;
  cursor: pointer;
  &:hover {
    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
  border: none;
  background-color: ${theme.palette.surface.default};
  box-shadow: 0 0 0 2px rgb(0 0 0 / 10%);
  border-radius: 4px;
`
